import { ref } from "vue";
import type { FormContext } from "vee-validate";

/**
 * 画面ロジックを扱う composable。
 */
export const useDeliverySettingUiState = () => {
  // UI制御フラグ
  const overlay = ref<boolean>(false);
  const errdialog = ref<boolean>(false);
  const errMessage = ref<string>("");
  const processFlag = ref<number>(0);
  const mode = ref<string>("time");

  // タブ選択用
  const model = ref(0);
  const panel = ref<number[]>([0]);

  // ダイアログ制御フラグ
  const displayInputDialog = ref<boolean>(false);
  const displayConfirmDialog = ref<boolean>(false);
  const displayCompletedDialog = ref<boolean>(false);
  const areaDeliveryIdResistDialog = ref<boolean>(false);

  //登録/更新完了フラグ
  const completeFlg = ref<boolean>(false);

  const selectShopFlg = ref<boolean>(false);
  const selectAreaFlg = ref<boolean>(false);

  // フォーム参照
  const timeFormRef = ref<FormContext | null>(null);
  const groupFormRef = ref<FormContext | null>(null);

  return {
    overlay,
    errdialog,
    errMessage,
    processFlag,
    mode,
    model,
    panel,
    displayInputDialog,
    displayConfirmDialog,
    displayCompletedDialog,
    areaDeliveryIdResistDialog,
    completeFlg,
    selectShopFlg,
    selectAreaFlg,
    timeFormRef,
    groupFormRef,
  };
};
